import React, { useEffect } from 'react';
import { useLocation, Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { ThemeProvider, makeStyles } from '@material-ui/core';
// import Brightness5Icon from '@material-ui/icons/Brightness5';
// import Brightness2Icon from '@material-ui/icons/Brightness2';

import Routes from './Routes';
import './App.css';
import Auth from './components/Auth/Auth';
import lightTheme from './views/theme';
import darkTheme from './views/themeDark';

const history = createBrowserHistory();

// Intercom renders a 48px launcher bubble. Matching the theme-toggle Fab to that
// size and reusing one padding value for both keeps the two controls the same
// size and lines up their centres, instead of guessing Intercom's defaults.
// const LAUNCHER_SIZE = 48;
const LAUNCHER_PADDING = 20;
// const LAUNCHER_GAP = 12;

// This project does not mount MUI's CssBaseline, so <body> had no background at
// all. Each view painted only its own `content` box, which left the browser's
// white showing through wherever that box did not reach: below short pages, and
// to the right of tables wide enough to scroll horizontally.
// A background on <body> propagates to the canvas and covers the whole
// scrollable area, so this fixes every route at once instead of per view.
// The body colour is set for the same reason: raw <p>/<li>/<td> elements with no
// styling of their own would otherwise inherit black and vanish on dark surfaces.
const useGlobalStyles = makeStyles((theme) => ({
  '@global': {
    // color-scheme tells the browser which palette to use for the chrome IT
    // draws: viewport scrollbars, the <input type="date"> picker, the autofill
    // dropdown, spinner arrows. It inherits, so declaring it on the root element
    // covers every route in one place.
    html: {
      colorScheme: theme.palette.type,
    },
    body: {
      backgroundColor: theme.palette.custom.pageBackground,
      color: theme.palette.text.primary,
      fontFamily: theme.typography.fontFamily,
    },
  },
}));

function GlobalStyles() {
  useGlobalStyles();
  return null;
}

// Only the public auth screens use the dark theme; every other route renders with
// the light theme. Matching is by exact pathname, so a new route that should be
// dark has to be added here explicitly.
const DARK_ROUTES = ['/', '/login', '/recover-password', '/reset-password', '/user-verification'];

function AppContent() {
  const location = useLocation();

  const isDarkRoute = DARK_ROUTES.includes(location.pathname);

  const theme = isDarkRoute ? darkTheme : lightTheme;

  useEffect(() => {
    const accent = theme.palette.custom.intercomAccent;

    const launcherSettings = {
      action_color: accent,
      background_color: accent,
      alignment: 'right',
      horizontal_padding: LAUNCHER_PADDING,
      vertical_padding: LAUNCHER_PADDING,
    };

    window.intercomSettings = {
      ...window.intercomSettings,
      ...launcherSettings,
    };

    if (typeof window.Intercom === 'function') {
      window.Intercom('update', launcherSettings);
    }
  }, [theme]);

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles />

      <Auth>
        <Routes />
      </Auth>

      {/* Theme toggle desactivado */}
    </ThemeProvider>
  );
}

function App() {
  return (
    <Router history={history}>
      <AppContent />
    </Router>
  );
}

export default App;
